import React, { PureComponent } from "react";
import ReactDropzone from "react-dropzone";

//import { TTP_API_URL } from "Config";
import styles from "./Wheretobill.local.scss";
import _ from "i18n";

export default class WheretobillComponent extends PureComponent {
  getAcceptedTypes() {
    return ["text/xml"];
  }

  render() {
    const { onDrop, onDragEnter, uploading, uploaded } = this.props;
    if (uploading) {
      return (
        <div className={styles.wheretobill}>
          <div className={styles.uploading}>
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 52 52"
              enable-background="new 0 0 0 0"
              style={{ width: "3rem", height: "3rem" }}
            >
              <circle fill="#18A0FB" stroke="none" cx="6" cy="25" r="6">
                <animate
                  attributeName="opacity"
                  dur="1s"
                  values="0;1;0"
                  repeatCount="indefinite"
                  begin="0.1"
                />
              </circle>
              <circle fill="#18A0FB" stroke="none" cx="26" cy="25" r="6">
                <animate
                  attributeName="opacity"
                  dur="1s"
                  values="0;1;0"
                  repeatCount="indefinite"
                  begin="0.2"
                />
              </circle>
              <circle fill="#18A0FB" stroke="none" cx="46" cy="25" r="6">
                <animate
                  attributeName="opacity"
                  dur="1s"
                  values="0;1;0"
                  repeatCount="indefinite"
                  begin="0.3"
                />
              </circle>
            </svg>
          </div>
        </div>
      );
    } else if (uploaded) {
      return (
        <div className={styles.wheretobill}>
          <div className={styles.uploaded}>
            <div className={styles.check}>
              <span className={styles.before} />
              <span className={styles.after} />
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={styles.wheretobill}>
        <ReactDropzone
          onDrop={onDrop}
          onDragEnter={onDragEnter}
          accept={this.getAcceptedTypes()}
          className={styles.dropzone}
          activeClassName="dropzone--active"
          rejectClassName="dropzone--reject"
        >
          <div className={styles.logo}>
            <div className={styles.imgContainer}>
              <img src="/img/icons/bill.svg" alt="bill" />
            </div>
            <img
              className={styles.arrow}
              src="/img/icons/arrow-to.svg"
              alt="arrow"
            />
            <div className={styles.imgContainer}>
              <img src="/img/icons/box.svg" alt="box" />
            </div>
          </div>
          <h4>{_("Where to bill")}</h4>
          <p>{_("Drop your files")}</p>
          <button>{_("Import")}</button>
          <span>{_("Maximum download file size: 8 MB.")}</span>
        </ReactDropzone>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Wheretobill/WheretobillComponent.js